<template>
  <CHeader with-subheader fixed>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('gui/toggleSidebarMobile')"/>
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('gui/toggleSidebarDesktop')"/>
    <CHeaderBrand
      class="mx-auto d-lg-none"
      src="img/brand_ob/logo.png"
      width="190"
      height="46"
      alt="Oceanbolt Logo"/>

    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/home">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>

    <CHeaderNav>
      <CBreadcrumbRouter class="border-0 mb-0"/>

      <filter-presets />

      <custom-switch label="Dark mode" v-model="darkMode" />

      <CHeaderNavItem class="px-3">
        <feedback />
      </CHeaderNavItem>

      <TheHeaderDropdownProfile />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import Feedback from '../components/Feedback'
import TheHeaderDropdownProfile from './TheHeaderDropdownProfile'
import FilterPresets from '../components/widgets/FilterPresets'
import CustomSwitch from '@/components/widgets/CustomSwitch'

export default {
  name: 'TheHeader',

  components: {
    CustomSwitch,
    FilterPresets,
    TheHeaderDropdownProfile,
    Feedback,
  },
  async mounted() {
    await this.isAdmin();
  },

  data() {
    return {
      admin: false,
    }
  },

  methods: {
    ...mapActions('api', ['is_admin']),
    ...mapMutations('gui', ['setDarkMode']),

    async isAdmin() {
      this.admin = await this.is_admin();
    }
  },

  computed: {
    darkMode: {
      get: function () {
        return this.$store.state.gui.darkMode;
      },

      set: function (value) {
        this.setDarkMode(value);
      },
    },
  },
}
</script>

<style scoped lang="scss">

</style>
